import { from } from "rxjs";
window.__APP_PRELOAD__ = window.__APP_PRELOAD__ || {};
function preloadApi() {
  return function(target, propertyKey, descriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = function(...args) {
      if (!window.__APP_PRELOAD__[propertyKey]) {
        window.__APP_PRELOAD__[propertyKey] = originalMethod.apply(this, args);
      }
      return from(window.__APP_PRELOAD__[propertyKey]);
    };
    return descriptor;
  };
}
export {
  preloadApi
};
